import { useState } from "react";
import styled from "@emotion/styled";
import { TextField } from "@mui/material";

import { BasicFlex, InputLabel } from "../../Common";

import ErrorMessage from "../../MuiFields/ErrorMessage";

const isValidEmail = (email) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);

const EmailField = ({ title = "Enter Email", email, setEmail, disabled = false }) => {

  return (
    <div>
      {/* <InputLabel>{title}</InputLabel> */}
      <TextField fullWidth size="small" label={title} value={email} onChange={(e) => setEmail(e.target.value)} disabled={disabled} />
      {email && !isValidEmail(email) && <ErrorMessage error={!isValidEmail(email)} message="Please enter a valid email address." /> }
    </div> 
  )
};

export default EmailField;